import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LeftPanelOpenSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LeftPanelOpenSVG;
